/* Mome bundle picker (Eurus) – used by sections/mome-bundle-travel.liquid.
   Each dress has a "Choose dress" button that opens a popup of products
   (from that dress block's collection or product list). Picking one loads its
   photo, name, price and size buttons. Optional rule: a different style for each
   dress (style = text before " in " in the product title). */
(function () {
  if (!window.customElements || customElements.get('mome-bundle-picker')) return;

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var fmt = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return fmt.replace(re, value);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function printKey(p) {
    return String((p && p.print) || '').trim().toLowerCase();
  }
  function firstAvailable(p) {
    if (!p || !p.variants.length) return null;
    return p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }
  function lowestPrice(p) {
    var v = firstAvailable(p);
    return v ? v.price : 0;
  }
  function joinList(items) {
    if (items.length < 2) return items.join('');
    return items.slice(0, -1).join(', ') + ' & ' + items[items.length - 1];
  }
  function styleKey(p) { return (p && p.style ? p.style : '').trim().toLowerCase(); }

  class MomeBundlePicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      var d = this.dataset;
      this.discount = parseFloat(d.discount) || 0;
      this.unique = d.unique === 'true';
      this.matchPrint = d.matchPrint === 'true';
      this.autoMatch = d.autoMatch === 'true';
      this.steps = d.steps === 'true';
      this.popupSizes = d.popupSizes === 'true';
      this.hoverImage = d.hoverImage !== 'false';
      this.fmt = d.moneyFormat;
      this.t = {
        soldOut: d.soldOut || 'Sold out',
        chooseDress: d.chooseDress || 'Choose [items].',
        chooseSize: d.chooseSize || 'Choose a size for [items].',
        save: d.saveTemplate || 'You save [amount] · [percent]% off',
        chosenFor: d.chosenFor || 'In [slot]',
        selected: d.selectedText || 'Selected',
        success: d.success || 'Added to your cart.',
        viewCart: d.viewCart || 'View cart',
        error: d.errorText || 'We couldn’t add your bundle. Please try again.',
        empty: d.emptyText || 'No dresses to show yet.',
        noMatch: d.noMatch || 'Not [slot]’s print',
        sizeFirst: d.sizeFirst || 'Choose a size first'
      };

      this.button = this.querySelector('[data-role="add"]');
      this.out = {
        compare: this.querySelector('[data-role="compare"]'),
        price: this.querySelector('[data-role="price"]'),
        save: this.querySelector('[data-role="save"]'),
        note: this.querySelector('[data-role="note"]'),
        status: this.querySelector('[data-role="status"]')
      };

      this.slots = Array.prototype.map.call(this.querySelectorAll('[data-slot]'), function (node, i) { return self.makeSlot(node, i); });

      this.setupBar();
      this.setupModal();
      this.slots.forEach(function (s) { self.renderSlot(s); });
      this.update();
      if (this.button) this.button.addEventListener('click', function (e) { e.preventDefault(); self.addToCart(); });
      this.setupSteps();
      /* A set chosen in the Mome matching set showcase: pick Mom's dress and ask for the size */
      this.addEventListener('mome:pick-set', function (e) { self.pickSet(e.detail || {}); });
      this.querySelectorAll('[data-role="add-more"]').forEach(function (b) {
        b.addEventListener('click', function () { if (self.step === 2) self.setStep(1, true); self.addSibling(b); });
      });
    }

    pickSet(detail) {
      var lead = this.slots[0];
      if (!lead || !this.modal) return;
      var list = this.modal.querySelector('[data-list="' + lead.listId + '"]');
      var self = this, pid = null, want = String(detail.print || '').trim().toLowerCase();
      if (list && detail.productId && list.querySelector('[data-pid="' + detail.productId + '"]')) pid = detail.productId;
      if (!pid && list && want) {
        Array.prototype.some.call(list.querySelectorAll('[data-pick]'), function (pick) {
          var e = self.products[pick.dataset.pid];
          if (e && printKey(e.data) === want && firstAvailable(e.data)) { pid = e.data.id; return true; }
          return false;
        });
      }
      if (!pid || !this.products[pid]) return;
      if (this.step === 2) this.setStep(1, true);
      this.activeSlot = lead;
      this.activeList = list;
      var go = function () {
        if (self.popupSizes && self.products[pid].data.variants.length > 1) self.openSheet(lead, pid, lead.box.change || lead.box.choose);
        else self.choose(lead, pid);
      };
      setTimeout(go, 450);
    }
    /* Matching sets: another dress for a sibling (copy of the second Dress block, no limit).
       The dress is only added once its size is picked. */
    addSibling(opener) {
      var self = this, lead = this.slots[0], twin = this.slots[1];
      if (!twin) return;
      var label = (this.dataset.extraLabel || 'Dress [n]').replace('[n]', this.slots.length);
      var pid = null;
      if (lead && lead.product && this.matchPrint) {
        var key = printKey(lead.product);
        pid = twin.product && printKey(twin.product) === key ? twin.product.id : this.findMatch(twin.listId, key);
      }
      if (!pid) {
        var empty = this.createSibling(label);
        this.update();
        empty.node.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var add = function (size) {
        var s = self.createSibling(label);
        self.choose(s, pid, size);
        if (self.complete && self.autoReview) setTimeout(function () { if (self.complete && self.step === 1) self.setStep(2); }, 450);
        else s.node.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      if (this.popupSizes && this.products[pid].data.variants.length > 1) this.openSheet({ label: label }, pid, opener, add);
      else add(null);
    }
    createSibling(label) {
      var self = this, d = this.dataset;
      var base = this.slots[1];
      var node = base.node.cloneNode(true);
      var n = this.slots.length;
      node.dataset.label = label;
      node.classList.remove('is-filled', 'is-waiting');
      node.removeAttribute('data-shopify-editor-block');
      var lab = node.querySelector('.mbx__slot-label-in');
      if (lab) { lab.innerHTML = ''; lab.appendChild(el('span', 'mbx__slot-name', label)); }
      node.querySelectorAll('.mbp-flash, .mbx__remove').forEach(function (x) { x.remove(); });
      var chosen = node.querySelector('[data-role="chosen"]');
      if (chosen) chosen.innerHTML = '';
      var rm = el('button', 'mbx__remove', d.removeLabel || 'Remove');
      rm.type = 'button';
      var labelEl = node.querySelector('.mbx__slot-label');
      if (labelEl) labelEl.appendChild(rm); else node.insertBefore(rm, node.firstChild);
      var last = this.slots[this.slots.length - 1].node;
      last.parentNode.insertBefore(node, last.nextSibling);
      var s = this.makeSlot(node, n);
      s.extra = true;
      s.label = label;
      this.slots.push(s);
      rm.addEventListener('click', function () { self.removeSlot(s); });
      this.renderSlot(s);
      return s;
    }
    removeSlot(s) {
      var i = this.slots.indexOf(s);
      if (i < 1) return;
      this.slots.splice(i, 1);
      s.node.remove();
      this.update();
    }

    makeSlot(node, i) {
      var self = this;
        var s = {
          node: node, index: i,
          listId: node.dataset.list,
          label: node.dataset.label || ('Dress ' + (i + 1)),
          popupTitle: node.dataset.popupTitle || node.dataset.label || '',
          product: null, variant: null,
          box: {
            empty: node.querySelector('[data-role="empty"]'),
            choose: node.querySelector('[data-role="choose"]'),
            chosen: node.querySelector('[data-role="chosen"]'),
            change: node.querySelector('[data-role="change"]'),
            actions: node.querySelector('[data-role="slot-actions"]'),
            view: node.querySelector('[data-role="slot-view"]'),
            sizeWrap: node.querySelector('[data-role="size-wrap"]'),
            sizes: node.querySelector('[data-role="sizes"]')
          }
        };
        [s.box.choose, s.box.change].forEach(function (b) {
          if (b) b.addEventListener('click', function (e) { e.preventDefault(); self.openPopup(s, b); });
        });
        if (s.box.view) s.box.view.addEventListener('click', function (e) {
          if (s.product) self.openQuickView(s.product.id, s, e.currentTarget);
        });
        if (s.box.chosen) s.box.chosen.addEventListener('click', function (e) {
          if (!e.target.closest('a') || !s.product) return;
          e.preventDefault();
          self.openQuickView(s.product.id, s, e.target.closest('a'));
        });
        return s;
    }

    /* Phones: closed price bar that opens on tap */
    setupBar() {
      var self = this;
      this.bar = this.querySelector('[data-role="summary"]');
      this.barToggle = this.querySelector('[data-role="bar-toggle"]');
      this.barTotal = this.querySelector('[data-role="bar-total"]');
      this.barCount = this.querySelector('[data-role="bar-count"]');
      if (!this.barToggle) return;
      this.barToggle.addEventListener('click', function () {
        var open = !self.bar.classList.contains('is-open');
        self.bar.classList.toggle('is-open', open);
        self.barToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    disconnectedCallback() {
      if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
    }

    /* ---------- popup ---------- */
    setupModal() {
      var self = this;
      this.products = {};
      this.modal = this.querySelector('[data-role="modal"]');
      this.qv = this.querySelector('[data-role="qv"]');
      if (!this.modal) { console.error('[Mome bundle] Popup markup is missing. Check that sections/mome-travel-bundle.liquid is the latest version.'); return; }
      if (!this.modal.querySelector('[data-pick]') && !this.modal.querySelector('[data-role="empty-list"]')) console.warn('[Mome bundle] The popup has no dresses. Check that snippets/mome-bundle-pick-item.liquid is uploaded and each Dress block has a collection or products.');
      /* Move the popups to the end of <body> so no theme container can trap them under other layers */
      document.body.appendChild(this.modal);
      if (this.qv) document.body.appendChild(this.qv);
      this.modalTitle = this.modal.querySelector('[data-role="modal-title"]');

      this.modal.querySelectorAll('[data-pick]').forEach(function (pick) {
        var data;
        try { data = JSON.parse(pick.querySelector('script[data-pick-json]').textContent); } catch (e) { return; }
        if (!self.products[data.id]) self.products[data.id] = { data: data, picks: [] };
        self.products[data.id].picks.push(pick);
        pick.querySelector('[data-role="pick-choose"]').addEventListener('click', function (e) {
          if (!self.activeSlot) return;
          if (self.popupSizes && data.variants.length > 1) { self.openSheet(self.activeSlot, data.id, e.currentTarget); return; }
          self.choose(self.activeSlot, data.id);
        });
        pick.querySelector('[data-role="pick-view"]').addEventListener('click', function (e) {
          self.openQuickView(data.id, self.activeSlot, e.currentTarget);
        });
        /* Like the Signature Set: tapping the photo or name opens the quick view instead of leaving the page */
        pick.querySelector('[data-pick-card]').addEventListener('click', function (e) {
          var a = e.target.closest('a');
          if (!a) return;
          e.preventDefault();
          self.openQuickView(data.id, self.activeSlot, a);
        });
      });

      this.modal.querySelectorAll('[data-role="modal-close"]').forEach(function (b) {
        b.addEventListener('click', function () { self.closePopup(); });
      });
      this.modal.addEventListener('keydown', function (e) { self.trapKeys(e, self.modal, function () { self.closePopup(); }); });

      if (this.qv) {
        this.qvBody = this.qv.querySelector('[data-role="qv-body"]');
        this.qvChoose = this.qv.querySelector('[data-role="qv-choose"]');
        this.qvNote = this.qv.querySelector('[data-role="qv-note"]');
        this.qv.querySelectorAll('[data-role="qv-close"]').forEach(function (b) {
          b.addEventListener('click', function () { self.closeQuickView(); });
        });
        this.qv.addEventListener('keydown', function (e) { self.trapKeys(e, self.qv, function () { self.closeQuickView(); }); });
        if (this.qvChoose) this.qvChoose.addEventListener('click', function () {
          if (self.qvSlot && self.qvProduct) {
            var id = self.qvProduct, slot = self.qvSlot;
            var entry = self.products[id];
            self.closeQuickView(true);
            if (self.popupSizes && entry && entry.data.variants.length > 1) self.openSheet(slot, id);
            else self.choose(slot, id);
          }
        });
      }
    }
    trapKeys(e, root, close) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(root.querySelectorAll('a[href], button:not(:disabled)'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    pickState(p, s) {
      var taken = this.takenBy(p, s);
      var soldOut = !p.variants.some(function (v) { return v.available; });
      var isCurrent = !!(s && s.product && s.product.id === p.id);
      var note = '';
      if (isCurrent) note = this.t.selected;
      else if (soldOut) note = this.t.soldOut;
      else if (taken) note = this.t.chosenFor.replace('[slot]', taken.label);
      var other = !isCurrent && !soldOut && !taken ? this.printClash(p, s) : null;
      if (other) note = this.t.noMatch.replace('[slot]', other.label).replace('[print]', other.product.print);
      return { blocked: !!taken || soldOut || !!other, current: isCurrent, note: note };
    }
    /* Matching sets: the first dress (Mom) sets the print; the other dresses must share it.
       Print = text after " in " in the title. */
    printClash(product, slot) {
      if (!this.matchPrint) return null;
      var lead = this.slots[0];
      if (!lead || slot === lead || !lead.product) return null;
      var key = printKey(product), leadKey = printKey(lead.product);
      if (!key || !leadKey || key === leadKey) return null;
      return lead;
    }
    takenBy(product, slot) {
      if (!this.unique) return null;
      var key = styleKey(product);
      if (!key) return null;
      return this.slots.find(function (o) { return o !== slot && o.product && styleKey(o.product) === key; }) || null;
    }
    openPopup(s, opener) {
      if (!this.modal) return;
      var self = this;
      this.activeSlot = s;
      this.opener = opener;
      if (this.modalTitle) this.modalTitle.textContent = s.popupTitle;
      var list = null;
      var emptyList = this.modal.querySelector('[data-role="empty-list"]');
      if (emptyList) emptyList.hidden = true;
      this.modal.querySelectorAll('[data-list]').forEach(function (g) {
        var on = g.dataset.list === s.listId;
        g.hidden = !on;
        if (on) list = g;
      });
      if (!list) {
        /* No dresses for this Dress block: say so instead of doing nothing */
        console.warn('[Mome bundle] No dress list found for', s.label, '- pick a collection or products in this Dress block.');
        list = this.modal.querySelector('[data-role="empty-list"]');
        if (list) list.hidden = false;
      }
      if (!list) return;
      this.activeList = list;
      list.querySelectorAll('[data-pick]').forEach(function (pick) {
        var entry = self.products[pick.dataset.pid];
        if (!entry) return;
        var st = self.pickState(entry.data, s);
        pick.classList.toggle('is-selected', st.current);
        pick.classList.toggle('is-blocked', st.blocked);
        var note = pick.querySelector('[data-role="pick-note"]');
        note.textContent = st.note;
        note.hidden = !st.note;
        pick.querySelector('[data-role="pick-choose"]').disabled = st.blocked;
        /* Matching prints first */
        pick.style.order = self.matchPrint && st.blocked && !st.current ? '1' : '';
      });
      this.modal.hidden = false;
      document.documentElement.classList.add('mbp-lock');
      var body = this.modal.querySelector('.mbp-modal__body');
      requestAnimationFrame(function () {
        self.modal.classList.add('is-open');
        var cur = list.querySelector('.mbp-pick.is-selected');
        if (body) body.scrollTop = cur ? Math.max(0, cur.offsetTop - 16) : 0;
        var target = (cur && cur.querySelector('[data-role="pick-choose"]')) || list.querySelector('[data-role="pick-choose"]:not(:disabled)') || self.modal.querySelector('[data-role="modal-close"]');
        if (target) target.focus({ preventScroll: true });
      });
    }
    /* Quick view photos: arrows under the photo (phones) and thumbnails (desktop) */
    setupQvGallery(root) {
      var track = root.querySelector('[data-qv-track]');
      if (!track) return;
      var thumbs = root.querySelectorAll('[data-qv-thumb]');
      var count = track.children.length;
      var go = function (i) {
        i = Math.max(0, Math.min(count - 1, i));
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      };
      var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      root.querySelectorAll('[data-qv-step]').forEach(function (b) {
        b.addEventListener('click', function () { go(current() + Number(b.dataset.qvStep)); });
      });
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { go(Number(b.dataset.qvThumb)); });
      });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = current();
          thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
          var a = thumbs[i];
          if (a && a.parentNode) a.parentNode.scrollTo({ left: a.offsetLeft - a.parentNode.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' });
        }, 80);
      }, { passive: true });
    }
    openQuickView(pid, slot, opener) {
      var entry = this.products[pid];
      if (!this.qv || !entry) return;
      var tpl = entry.picks[0].querySelector('template[data-pick-qv]');
      if (!tpl) return;
      this.qvSlot = slot || this.activeSlot;
      this.qvProduct = pid;
      this.qvOpener = opener;
      this.qvBody.innerHTML = '';
      this.qvBody.appendChild(tpl.content.cloneNode(true));
      this.setupQvGallery(this.qvBody);
      var st = this.pickState(entry.data, this.qvSlot);
      var foot = this.qvChoose && this.qvChoose.parentElement;
      if (foot) foot.hidden = !this.qvSlot;
      if (this.qvChoose) this.qvChoose.disabled = st.blocked || (st.current && !this.popupSizes);
      if (this.qvNote) { this.qvNote.textContent = st.note; this.qvNote.hidden = !st.note; }
      this.qv.hidden = false;
      document.documentElement.classList.add('mbp-lock');
      var self = this;
      requestAnimationFrame(function () {
        self.qv.classList.add('is-open');
        var c = self.qv.querySelector('.mbq__close');
        if (c) c.focus({ preventScroll: true });
      });
    }
    closeQuickView(silent) {
      if (!this.qv || this.qv.hidden) return;
      var self = this;
      this.qv.classList.remove('is-open');
      this.qv.hidden = true;
      this.qvBody.innerHTML = '';
      if (this.modal.hidden) document.documentElement.classList.remove('mbp-lock');
      if (!silent && this.qvOpener && this.qvOpener.isConnected) this.qvOpener.focus({ preventScroll: true });
      /* Opened from the size popup: go back to it */
      var back = this._qvBackToSheet;
      this._qvBackToSheet = null;
      if (!silent && back) this.openSheet(back.slot, back.pid, null, back.onConfirm);
    }
    closePopup() {
      if (!this.modal || this.modal.hidden) return;
      var self = this;
      this.modal.classList.remove('is-open');
      document.documentElement.classList.remove('mbp-lock');
      setTimeout(function () { self.modal.hidden = true; }, 200);
      if (this.opener && this.opener.isConnected && !this.opener.hidden) this.opener.focus({ preventScroll: true });
      else if (this.activeSlot && this.activeSlot.box.change) this.activeSlot.box.change.focus({ preventScroll: true });
    }
    /* Size sheet (like the Signature Set): Choose opens a small panel to pick the size */
    setupSheet() {
      var self = this, d = this.dataset;
      if (!this.popupSizes || this.sheet) return;
      var sh = el('div', 'mbx mbp-sheet' + (this.classList.contains('is-rounded') ? ' is-rounded' : ''));
      sh.hidden = true;
      sh.setAttribute('data-lenis-prevent', '');
      sh.innerHTML =
        '<button type="button" class="mbp-sheet__backdrop" data-sheet-close></button>' +
        '<div class="mbp-sheet__panel" role="dialog" aria-modal="true">' +
          '<div class="mbp-sheet__head">' +
            '<img class="mbp-sheet__img" alt="" width="56" height="84">' +
            '<div class="mbp-sheet__info"><span class="mbp-sheet__kicker"></span><span class="mbp-sheet__name"></span><span class="mbp-sheet__price"></span></div>' +
            '<button type="button" class="mbp-sheet__close" data-sheet-close>&times;</button>' +
          '</div>' +
          '<div class="mbp-sheet__row"><span class="mbp-sheet__heading"></span></div>' +
          '<button type="button" class="mbp-sheet__details"></button>' +
          '<div class="mbp-sheet__sizes" role="group"></div>' +
          '<button type="button" class="button button-solid not-icon leading-normal w-full pr-5 pl-5 pt-3 pb-3 disabled:cursor-not-allowed disabled:opacity-60 mbp-sheet__confirm"></button>' +
        '</div>';
      var heading = d.sheetHeading || 'Choose a size';
      sh.querySelector('.mbp-sheet__heading').textContent = heading;
      sh.querySelector('.mbp-sheet__panel').setAttribute('aria-label', heading);
      sh.querySelector('.mbp-sheet__sizes').setAttribute('aria-label', heading);
      sh.querySelectorAll('[data-sheet-close]').forEach(function (b) {
        b.setAttribute('aria-label', d.closeLabel || 'Close');
        b.addEventListener('click', function () { self.closeSheet(); });
      });
      if (d.sizeGuideUrl) {
        var a = el('a', 'mbp-sheet__guide', d.sizeGuideLabel || 'Size guide');
        a.href = d.sizeGuideUrl; a.target = '_blank'; a.rel = 'noopener';
        sh.querySelector('.mbp-sheet__row').appendChild(a);
      }
      /* Details link removed: the popup cards already have a View button */
      var oldDet = sh.querySelector('.mbp-sheet__details:not(.mbp-sheet__chart)');
      if (oldDet) oldDet.remove();
      /* Size chart: opens just the chart image on top of the size popup */
      var chartBtn = el('button', 'mbp-sheet__details mbp-sheet__chart', d.sizeChartLabel || 'Size chart');
      chartBtn.type = 'button';
      chartBtn.hidden = true;
      sh.querySelector('.mbp-sheet__row').appendChild(chartBtn);
      chartBtn.addEventListener('click', function () { if (self.sheetState) self.openChart(self.sheetState.pid, chartBtn); });
      this.sheetChartBtn = chartBtn;
      this.sheetConfirm = sh.querySelector('.mbp-sheet__confirm');
      this.sheetConfirm.addEventListener('click', function () {
        if (!self.sheetState || !self.sheetState.size) return;
        var st = self.sheetState;
        self.closeSheet(true);
        if (st.onConfirm) st.onConfirm(st.size);
        else self.choose(st.slot, st.pid, st.size);
      });
      sh.addEventListener('keydown', function (e) { self.trapKeys(e, sh.querySelector('.mbp-sheet__panel'), function () { self.closeSheet(); }); });
      document.body.appendChild(sh);
      this.sheet = sh;
    }
    chartTemplate(pid) {
      var entry = this.products[pid];
      var tpl = entry && entry.picks && entry.picks[0] ? entry.picks[0].querySelector('template[data-pick-chart]') : null;
      return tpl && tpl.content.querySelector('img') ? tpl : null;
    }
    openChart(pid, opener) {
      var tpl = this.chartTemplate(pid), self = this, d = this.dataset;
      if (!tpl) return;
      if (!this.chartBox) {
        var c = el('div', 'mbx mbp-chart' + (this.classList.contains('is-rounded') ? ' is-rounded' : ''));
        c.hidden = true;
        c.setAttribute('data-lenis-prevent', '');
        c.setAttribute('role', 'dialog');
        c.setAttribute('aria-modal', 'true');
        c.innerHTML = '<div class="mbp-chart__backdrop" data-chart-close></div>' +
          '<div class="mbp-chart__panel"><div class="mbp-chart__head"><h2 class="mbp-chart__title h4"></h2>' +
          '<button type="button" class="mbp-chart__close" data-chart-close><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
          '<div class="mbp-chart__body"></div></div>';
        c.querySelector('.mbp-chart__title').textContent = d.chartHeading || d.sizeChartLabel || 'Size chart';
        c.setAttribute('aria-label', d.chartHeading || 'Size chart');
        c.querySelector('.mbp-chart__close').setAttribute('aria-label', d.closeLabel || 'Close');
        c.addEventListener('click', function (e) { if (e.target.closest('[data-chart-close]')) self.closeChart(); });
        c.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); self.closeChart(); } });
        document.body.appendChild(c);
        this.chartBox = c;
      }
      this.chartOpener = opener || null;
      var body = this.chartBox.querySelector('.mbp-chart__body');
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      this.chartBox.hidden = false;
      requestAnimationFrame(function () { var x = self.chartBox.querySelector('.mbp-chart__close'); if (x) x.focus({ preventScroll: true }); });
    }
    closeChart() {
      if (!this.chartBox || this.chartBox.hidden) return;
      this.chartBox.hidden = true;
      this.chartBox.querySelector('.mbp-chart__body').innerHTML = '';
      if (this.chartOpener && this.chartOpener.isConnected) this.chartOpener.focus({ preventScroll: true });
    }
    openSheet(slot, pid, opener, onConfirm) {
      var self = this, entry = this.products[pid];
      if (!entry) return;
      this.setupSheet();
      var p = entry.data, sh = this.sheet;
      var current = slot.product && slot.product.id === p.id && slot.variant ? slot.variant.size : null;
      this.sheetState = { slot: slot, pid: pid, size: current, opener: opener || null, onConfirm: onConfirm || null };
      var img = sh.querySelector('.mbp-sheet__img');
      img.src = p.thumb || p.image || '';
      img.hidden = !(p.thumb || p.image);
      sh.querySelector('.mbp-sheet__kicker').textContent = slot.label;
      sh.querySelector('.mbp-sheet__name').textContent = p.title;
      var v0 = firstAvailable(p) || p.variants[0];
      sh.querySelector('.mbp-sheet__price').textContent = v0 ? formatMoney(v0.price, this.fmt) : '';
      if (this.sheetChartBtn) this.sheetChartBtn.hidden = !this.chartTemplate(pid);
      var box = sh.querySelector('.mbp-sheet__sizes');
      box.innerHTML = '';
      p.variants.forEach(function (v) {
        var b = el('button', 'mbx-option mbp-sheet__size' + (v.available ? '' : ' is-soldout'), v.size);
        b.type = 'button';
        b.disabled = !v.available;
        b.dataset.size = v.size;
        b.setAttribute('aria-label', v.size + (v.available ? '' : ', ' + self.t.soldOut));
        b.addEventListener('click', function () {
          self.sheetState.size = v.size;
          self.renderSheet();
        });
        box.appendChild(b);
      });
      this.renderSheet();
      sh.hidden = false;
      requestAnimationFrame(function () {
        sh.classList.add('is-open');
        var f = box.querySelector('.is-selected') || box.querySelector('button:not(:disabled)');
        if (f) f.focus({ preventScroll: true });
      });
    }
    renderSheet() {
      var st = this.sheetState, d = this.dataset;
      if (!st || !this.sheet) return;
      this.sheet.querySelectorAll('.mbp-sheet__size').forEach(function (b) {
        var on = b.dataset.size === st.size;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.sheetConfirm.disabled = !st.size;
      this.sheetConfirm.textContent = st.size
        ? (d.sheetAdd || 'Add [size] to bundle').replace('[size]', st.size)
        : (d.sheetSelect || 'Select a size');
    }
    closeSheet(silent) {
      var sh = this.sheet, st = this.sheetState;
      if (!sh || sh.hidden) return;
      sh.classList.remove('is-open');
      setTimeout(function () { sh.hidden = true; }, 180);
      if (!silent && st && st.opener && st.opener.isConnected) st.opener.focus({ preventScroll: true });
      this.sheetState = silent ? st : null;
    }

    /* Steps: 1 choose the dresses, 2 review and add to cart */
    setupSteps() {
      var self = this;
      if (!this.steps) return;
      this.step = 1;
      this._wasComplete = false;
      this.stepNav = this.querySelector('[data-role="steps"]');
      this.reviewStep = this.querySelector('[data-role="review-step"]');
      this.reviewRows = this.querySelector('[data-role="review-rows"]');
      this.toReview = this.querySelector('[data-role="to-review"]');
      if (this.toReview) this.toReview.addEventListener('click', function () { self.setStep(2); });
      this.autoReview = this.dataset.autoReview === 'true';
      this.progressBar = this.querySelector('[data-role="progress"]');
      this.progressFill = this.querySelector('[data-role="progress-fill"]');
      this.stepStatus = this.querySelector('[data-role="step-status"]');
      this.summaryAdd = this.button;
      this.summaryStatus = this.out.status;
      this.reviewAdd = this.querySelector('[data-role="add-review"]');
      this.reviewStatus = this.querySelector('[data-role="review-status"]');
      this.rv = {
        original: this.querySelector('[data-role="rv-original"]'),
        savings: this.querySelector('[data-role="rv-savings"]'),
        total: this.querySelector('[data-role="rv-total"]'),
        label: this.querySelector('[data-role="add-review-label"]')
      };
      if (this.reviewAdd) this.reviewAdd.addEventListener('click', function (e) { e.preventDefault(); self.addToCart(); });
      var so = this.querySelector('[data-role="start-over"]');
      if (so) so.addEventListener('click', function () { self.startOver(); });
      this.querySelectorAll('[data-role="go-step"]').forEach(function (b) {
        b.addEventListener('click', function () { self.setStep(Number(b.dataset.step)); });
      });
    }
    setStep(n, keepScroll) {
      if (!this.steps) return;
      if (n === 2 && !this.complete) n = 1;
      this.step = n;
      this.dataset.step = String(n);
      if (this.reviewStep) this.reviewStep.hidden = n !== 2;
      if (this.stepNav) this.stepNav.querySelectorAll('.mbx__step').forEach(function (tab) {
        var k = Number(tab.dataset.step);
        tab.classList.toggle('is-current', k === n);
        tab.classList.toggle('is-active', k === n);
        tab.classList.toggle('is-done', k < n);
        tab.setAttribute('aria-current', k === n ? 'step' : 'false');
        var num = tab.querySelector('.mbx__tab-num');
        if (num) num.textContent = k < n ? '✓' : num.dataset.num;
      });
      /* Step 2 has its own add button and message */
      if (this.reviewAdd) {
        this.button = n === 2 ? this.reviewAdd : this.summaryAdd;
        this.out.status = n === 2 && this.reviewStatus ? this.reviewStatus : this.summaryStatus;
        this._keepStatus = false;
        this.update();
      }
      if (this.bar) { this.bar.classList.remove('is-open'); if (this.barToggle) this.barToggle.setAttribute('aria-expanded', 'false'); }
      if (n === 2) this.renderReviewStep();
      if (!keepScroll) {
        var top = (this.stepNav || this).getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }
    renderReviewStep() {
      var self = this, box = this.reviewRows;
      if (!box) return;
      box.innerHTML = '';
      this.slots.forEach(function (s) {
        var p = s.product, v = s.variant;
        if (!p) return;
        var row = el('div', 'mbx__rrow');
        var img = document.createElement('img');
        img.className = 'mbx__rrow-img';
        img.src = p.thumb || p.image || '';
        img.alt = p.title;
        img.width = 84; img.height = 126;
        row.appendChild(img);
        var info = el('div', 'mbx__rrow-info');
        info.appendChild(el('span', 'mbx__rrow-label', s.label));
        info.appendChild(el('span', 'mbx__rrow-name', p.title));
        if (v) info.appendChild(el('span', 'mbx__rrow-size', (self.dataset.sizeWord || 'Size') + ': ' + v.size));
        var ch = el('button', 'mbx__rv-link', self.dataset.changeLabel || 'Change');
        ch.type = 'button';
        ch.addEventListener('click', function () { self.setStep(1, true); self.openPopup(s, ch); });
        var links = el('span', 'mbx__rrow-links');
        links.appendChild(ch);
        if (s.extra) {
          var rm = el('button', 'mbx__rv-link', self.dataset.removeLabel || 'Remove');
          rm.type = 'button';
          rm.addEventListener('click', function () { self.removeSlot(s); });
          links.appendChild(rm);
        }
        info.appendChild(links);
        row.appendChild(info);
        row.appendChild(el('span', 'mbx__rrow-price', v ? formatMoney(v.price, self.fmt) : ''));
        box.appendChild(row);
      });
      var regular = 0;
      this.slots.forEach(function (s) { if (s.variant) regular += Number(s.variant.price) || 0; });
      var sale = Math.round(regular * (1 - this.discount / 100));
      if (this.rv.original) this.rv.original.textContent = formatMoney(regular, this.fmt);
      if (this.rv.savings) this.rv.savings.textContent = '−' + formatMoney(regular - sale, this.fmt);
      if (this.rv.total) this.rv.total.textContent = formatMoney(sale, this.fmt);
      if (this.rv.label && this.reviewAdd && !this._busy) {
        var lbl = this.reviewAdd.dataset.label || 'Add to cart';
        this.rv.label.textContent = this.reviewAdd.dataset.showPrice === 'true' ? lbl + ' · ' + formatMoney(sale, this.fmt) : lbl;
      }
    }
    startOver() {
      var self = this;
      this.slots.forEach(function (s) { s.product = null; s.variant = null; s.cardCopy = null; self.renderSlot(s); });
      this._keepStatus = false;
      this.setStep(1);
      this.update();
    }

    choose(s, pid, pickedSize) {
      var entry = this.products[pid];
      if (!entry) return;
      var p = entry.data;
      if (this.pickState(p, s).blocked) return;
      var size = pickedSize || (s.variant && s.variant.size);
      s.product = p;
      /* Matching sets: a new print clears dresses in another print */
      if (this.matchPrint) {
        var key = printKey(p);
        this.slots.forEach(function (o) {
          if (o === s || !o.product || !key || printKey(o.product) === key) return;
          o.product = null; o.variant = null; o.cardCopy = null;
          this.renderSlot(o);
        }, this);
      }
      var card = (this.activeList && this.activeList.querySelector('[data-pid="' + pid + '"] [data-pick-card]')) || entry.picks[0].querySelector('[data-pick-card]');
      s.cardCopy = card ? this.staticCard(card, p) : null;
      s.variant = size ? p.variants.find(function (v) { return v.size === size && v.available; }) || null : null;
      if (!s.variant && p.variants.length === 1 && p.variants[0].available) s.variant = p.variants[0];
      this.closePopup();
      this.renderSlot(s);
      this.update();
      if (s.box.change) s.box.change.focus({ preventScroll: true });
      if (this.matchPrint && this.autoMatch && s === this.slots[0]) this.fillMatches(s);
    }
    /* Matching sets: after Mom's dress, pick the dress in the same print for the other slots
       (first available one in that slot's collection), then ask for its size */
    fillMatches(lead) {
      var self = this, key = printKey(lead.product);
      if (!key || !this.modal) return;
      var next = null;
      this.slots.forEach(function (o) {
        if (o === lead) return;
        /* A dress in another print no longer matches: clear it */
        if (o.product && printKey(o.product) !== key) {
          o.product = null; o.variant = null; o.cardCopy = null;
          self.renderSlot(o);
        }
        if (next || (o.product && o.variant)) return;
        var pid = o.product ? o.product.id : self.findMatch(o.listId, key);
        if (!pid) {
          self.renderSlot(o);
          self.flash(o, (self.dataset.noMatchFound || 'No [print] dress for [slot] yet. Choose another.').replace('[print]', lead.product.print).replace('[slot]', o.label));
          return;
        }
        next = { slot: o, pid: pid };
      });
      this.update();
      if (!next) return;
      var o = next.slot, pid = next.pid, data = this.products[pid].data;
      var done = function (size) {
        self.choose(o, pid, size);
        self.flash(o, (self.dataset.autoMatched || 'Matched to [print]').replace('[print]', lead.product.print));
        self.fillMatches(lead);
      };
      /* The girl's dress is only added once her size is picked */
      if (this.popupSizes && data.variants.length > 1) {
        setTimeout(function () { self.openSheet(o, pid, o.box.choose, done); }, 260);
      } else {
        done(null);
      }
    }
    /* The "Add another dress" card takes the height of the dress photos next to it */
    sizeAddCard() {
      var self = this;
      var btn = this.querySelector('.mbx__add-card-btn');
      if (!btn) return;
      if (!this._addCardResize) {
        this._addCardResize = true;
        window.addEventListener('resize', function () { self.sizeAddCard(); });
      }
      requestAnimationFrame(function () {
        var img = self.querySelector('.mbp-chosen img');
        var box = img && (img.closest('.mbp-hover-holder') || img.closest('.media-slide') || img);
        var h = box ? box.getBoundingClientRect().height : 0;
        btn.style.height = h > 40 ? h + 'px' : '';
        btn.style.paddingTop = h > 40 ? '0' : '';
      });
    }
    /* First available dress in this print in a Dress block's collection */
    findMatch(listId, key) {
      var self = this, found = null;
      var list = this.modal && this.modal.querySelector('[data-list="' + listId + '"]');
      if (!list) return null;
      Array.prototype.some.call(list.querySelectorAll('[data-pick]'), function (pick) {
        var e = self.products[pick.dataset.pid];
        if (!e || printKey(e.data) !== key || !firstAvailable(e.data)) return false;
        found = e.data.id;
        return true;
      });
      return found;
    }
    /* Short note above a dress, e.g. "Matched to Rose Garden" */
    flash(s, text) {
      var n = s.node.querySelector('.mbp-flash');
      if (!n) {
        n = el('p', 'mbp-flash');
        n.setAttribute('role', 'status');
        var card = s.node.querySelector('.mbx__card');
        card.insertBefore(n, card.firstChild);
      }
      n.textContent = text;
      n.hidden = false;
      clearTimeout(s._flashT);
      s._flashT = setTimeout(function () { n.hidden = true; }, 6000);
    }

    /* ---------- slot ---------- */
    renderSlot(s) {
      var b = s.box;
      var p = s.product;
      s.node.classList.toggle('is-filled', !!p);
      /* Matching sets: the girl's dress waits for Mom's choice instead of showing a Choose button */
      var lead = this.slots && this.slots[0];
      var waiting = this.matchPrint && this.autoMatch && lead && s !== lead && !p && !lead.product;
      s.node.classList.toggle('is-waiting', !!waiting);
      if (waiting && b.empty && !b.empty.querySelector('.mbp-wait')) b.empty.appendChild(el('p', 'mbp-wait', this.dataset.waitText || 'Choose the first dress. The match appears here.'));
      if (b.empty) b.empty.hidden = !!p;
      if (b.actions) b.actions.hidden = !p;
      if (b.chosen) {
        b.chosen.hidden = !p;
        b.chosen.innerHTML = '';
        if (p && s.cardCopy) {
          b.chosen.appendChild(s.cardCopy);
          this.cardSize(s);
        }
      }
      this.renderSizes(s);
    }
    /* Copy of the Eurus card shown in the popup, without its scripts, so it looks the same in the dress slot */
    staticCard(card, p) {
      var clone = card.cloneNode(true);
      /* Drop pieces that are hidden on the live card (loading layers, hover panels, buttons) */
      var src = [card].concat(Array.prototype.slice.call(card.querySelectorAll('*')));
      var dst = [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*')));
      var drop = [];
      src.forEach(function (n, i) {
        if (i === 0 || !dst[i]) return;
        var cs = window.getComputedStyle(n);
        if (n.hasAttribute('x-cloak') || cs.display === 'none' || cs.visibility === 'hidden' || (cs.opacity === '0' && n.tagName !== 'IMG' && !n.querySelector('img'))) drop.push(dst[i]);
      });
      drop.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*'))).forEach(function (n) {
        Array.prototype.slice.call(n.attributes).forEach(function (a) {
          if (/^(x-|@|:)/.test(a.name)) n.removeAttribute(a.name);
        });
        if (n.id) n.removeAttribute('id');
      });
      clone.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      clone.querySelectorAll('.animate_transition_card__image, .animate_transition_image').forEach(function (el) { el.classList.add('active', 'lazy_active'); });
      clone.removeAttribute('data-pick-card');
      clone.classList.add('mbp-chosen__card');
      if (this.hoverImage && p && p.image2) this.addHoverImage(clone, p);
      return clone;
    }
    /* Second photo that fades in when the chosen dress is hovered (desktop) */
    addHoverImage(clone, p) {
      var first = clone.querySelector('img');
      if (!first) return;
      var holder = first.closest('.media-slide') || first.parentNode;
      if (holder.tagName === 'PICTURE') holder = holder.parentNode;
      /* Eurus's own extra slides need its slider script, so the copy uses this layer instead */
      clone.querySelectorAll('.media-slide').forEach(function (n) { if (n !== holder && !n.contains(holder)) n.classList.add('mbp-hide-slide'); });
      var img = document.createElement('img');
      img.className = 'mbp-hover-img';
      img.src = p.image2;
      img.alt = p.image2_alt || '';
      img.loading = 'lazy';
      img.setAttribute('aria-hidden', 'true');
      holder.classList.add('mbp-hover-holder');
      holder.appendChild(img);
      clone.classList.add('has-hover-img');
    }
    /* "Size: M" right after the price on the chosen dress card */
    cardSize(s) {
      var card = s.cardCopy;
      if (!card) return;
      card.querySelectorAll('.mbp-card-size, .mbp-card-size-break').forEach(function (n) { n.remove(); });
      if (!this.popupSizes || !s.variant) return;
      if (s.product.variants.length === 1 && s.variant.size === 'One size') return;
      var price = card.querySelector('.x-card-price');
      if (!price) return;
      price.appendChild(el('span', 'mbp-card-size-break'));
      price.appendChild(el('span', 'mbp-card-size', (this.dataset.sizeWord || 'Size') + ': ' + s.variant.size));
    }
    renderSizes(s) {
      var self = this;
      var box = s.box.sizes;
      if (!box) return;
      box.innerHTML = '';
      if (s.box.sizeWrap) s.box.sizeWrap.hidden = !s.product;
      if (!s.product) return;
      /* Size chosen in the size popup: shown as text right under the price (see cardSize) */
      if (this.popupSizes) {
        var wrap = s.box.sizeWrap;
        if (wrap) wrap.classList.add('is-text');
        box.removeAttribute('role');
        var inCard = s.cardCopy && s.cardCopy.querySelector('.mbp-card-size');
        if (s.variant && !inCard && !(s.product.variants.length === 1 && s.variant.size === 'One size')) {
          box.appendChild(el('p', 'mbp-slot__size', (this.dataset.sizeWord || 'Size') + ': ' + s.variant.size));
        } else if (wrap) {
          wrap.hidden = true;
        }
        return;
      }
      /* Two rows at most on phones: half the sizes per row, rounded up */
      box.style.setProperty('--mbp-size-cols', Math.max(1, Math.ceil(s.product.variants.length / 2)));
      s.product.variants.forEach(function (v) {
        var btn = el('button', 'mbx-option' + (s.variant && s.variant.id === v.id ? ' is-selected' : '') + (v.available ? '' : ' is-soldout'), v.size);
        btn.type = 'button';
        btn.disabled = !v.available;
        btn.setAttribute('aria-pressed', s.variant && s.variant.id === v.id ? 'true' : 'false');
        btn.setAttribute('aria-label', v.size + (v.available ? '' : ', ' + self.t.soldOut));
        btn.addEventListener('click', function () {
          s.variant = v;
          self.renderSlot(s);
          self.update();
        });
        box.appendChild(btn);
      });
    }

    /* ---------- totals ---------- */
    cheapestIn(listId) {
      var self = this, best = null;
      if (!this.modal) return null;
      var list = this.modal.querySelector('[data-list="' + listId + '"]');
      if (!list) return null;
      list.querySelectorAll('[data-pick]').forEach(function (pick) {
        var e = self.products[pick.dataset.pid];
        if (!e) return;
        var v = firstAvailable(e.data);
        if (v && (!best || v.price < best.price)) best = v;
      });
      return best;
    }
    /* Phones: list of the dresses inside the opened price bar (like the Signature Set) */
    renderReview() {
      var self = this, d = this.dataset;
      var box = this.querySelector('[data-role="review"]');
      if (!box) return;
      box.innerHTML = '';
      this.slots.forEach(function (s) {
        var p = s.product, v = s.variant;
        var row = el('div', 'mbx__rv-row' + (p ? '' : ' is-empty'));
        if (p && (p.thumb || p.image)) {
          var img = document.createElement('img');
          img.className = 'mbx__rv-img';
          img.src = p.thumb || p.image;
          img.alt = p.title;
          img.width = 34;
          img.height = 46;
          img.loading = 'lazy';
          row.appendChild(img);
        } else {
          row.appendChild(el('span', 'mbx__rv-img is-empty', '+'));
        }
        var info = el('span', 'mbx__rv-info');
        info.appendChild(el('span', 'mbx__rv-label', s.label));
        info.appendChild(el('span', 'mbx__rv-name', p ? p.title : (d.reviewEmpty || 'Not chosen yet')));
        if (p) info.appendChild(el('span', 'mbx__rv-size' + (v ? '' : ' is-missing'), v ? v.size : (d.reviewSize || 'Choose a size')));
        var link = el('button', 'mbx__rv-link', p ? (d.changeLabel || 'Change') : (d.pickLabel || 'Choose'));
        link.type = 'button';
        link.addEventListener('click', function () { self.openPopup(s, link); });
        info.appendChild(link);
        row.appendChild(info);
        var pv = v || (p && firstAvailable(p));
        row.appendChild(el('span', 'mbx__rv-price', pv ? formatMoney(pv.price, self.fmt) : ''));
        box.appendChild(row);
      });
    }
    /* Small photo per dress in the price bar (dashed + until chosen) */
    renderMinis() {
      var self = this;
      this.querySelectorAll('[data-role="minis"]').forEach(function (box) {
        box.innerHTML = '';
        self.slots.forEach(function (s) {
          var p = s.product;
          var m = el('span', 'mbx__mini' + (p ? '' : ' is-empty'));
          if (p && (p.thumb || p.image)) {
            var img = document.createElement('img');
            img.src = p.thumb || p.image;
            img.alt = '';
            img.width = 28;
            img.height = 38;
            m.appendChild(img);
          } else {
            m.textContent = '+';
          }
          box.appendChild(m);
        });
      });
    }
    update() {
      var self = this;
      var regular = 0, needDress = [], needSize = [];
      this.slots.forEach(function (s) {
        var v = s.variant;
        if (!s.product) needDress.push(s.label);
        else if (!v) needSize.push(s.label);
        /* Only dresses that have been chosen count toward the total; empty dresses add 0 */
        if (!v && s.product) v = firstAvailable(s.product);
        if (v) regular += Number(v.price) || 0;
      });
      var complete = !needDress.length && !needSize.length && this.slots.length > 0;
      var sale = Math.round(regular * (1 - this.discount / 100));
      if (this.out.compare) { this.out.compare.textContent = formatMoney(regular, this.fmt); this.out.compare.hidden = this.discount <= 0; }
      if (this.out.price) this.out.price.textContent = formatMoney(sale, this.fmt);
      if (this.out.save) {
        this.out.save.textContent = this.t.save
          .replace('[amount]', formatMoney(regular - sale, this.fmt))
          .replace('[percent]', String(this.discount).replace(/\.0+$/, ''));
        this.out.save.hidden = this.discount <= 0;
      }
      if (this.out.note) this.out.note.hidden = !needSize.length;
      if (this.barTotal) this.barTotal.textContent = formatMoney(sale, this.fmt);
      this.renderMinis();
      this.renderReview();
      if (this.barCount) {
        var chosen = this.slots.filter(function (s) { return !!s.product; }).length;
        this.barCount.textContent = (this.dataset.barCount || '[chosen] of [total] dresses chosen').replace('[chosen]', chosen).replace('[total]', this.slots.length);
      }
      if (this.out.status && !this._busy && !this._keepStatus) {
        var msg = '';
        if (needDress.length) msg = this.t.chooseDress.replace('[items]', joinList(needDress));
        else if (needSize.length) msg = this.t.chooseSize.replace('[items]', joinList(needSize));
        this.out.status.textContent = msg;
        this.out.status.classList.remove('is-success', 'is-error');
      }
      this._keepStatus = false;
      this.complete = complete;
      if (this.button) this.button.disabled = !complete || !!this._busy;
      this.classList.toggle('has-lead', !!(this.slots[0] && this.slots[0].product));
      this.sizeAddCard();
      if (this.steps) {
        if (this.toReview) this.toReview.hidden = !complete;
        if (this.bar) this.bar.classList.toggle('is-complete', complete);
        var nav2 = this.stepNav && this.stepNav.querySelector('[data-role="go-step"][data-step="2"]');
        if (nav2) nav2.disabled = !complete;
        var done = this.slots.filter(function (s) { return !!s.variant; }).length;
        var total = this.slots.length;
        if (this.progressFill) this.progressFill.style.width = (total ? done / total * 100 : 0) + '%';
        if (this.progressBar) this.progressBar.setAttribute('aria-valuenow', String(done));
        if (this.stepStatus) {
          this.stepStatus.textContent = complete
            ? (this.dataset.msgComplete || 'Complete. Review it and add to cart.')
            : (this.dataset.msgProgress || '[chosen] of [total] chosen.').replace('[chosen]', done).replace('[total]', total).replace('[left]', total - done);
          this.stepStatus.classList.toggle('is-complete', complete);
        }
        var becameComplete = complete && this._wasComplete === false;
        this._wasComplete = complete;
        if (this.step === 2 && !complete) this.setStep(1, true);
        else if (this.step === 2) this.renderReviewStep();
        else if (becameComplete && this.autoReview && !this._busy) {
          var self2 = this;
          clearTimeout(this._autoT);
          this._autoT = setTimeout(function () {
            if (self2.complete && self2.step === 1 && !(self2.sheet && !self2.sheet.hidden) && (!self2.modal || self2.modal.hidden)) self2.setStep(2);
          }, 450);
        }
      }
    }

    /* ---------- cart ---------- */
    cartStore() {
      try { return window.Alpine && window.Alpine.store ? window.Alpine.store('xMiniCart') : null; }
      catch (e) { return null; }
    }
    async openEurusDrawer() {
      var store = this.cartStore();
      if (!store || typeof store.openCart !== 'function') return false;
      try { store.needReload = true; } catch (e) {}
      if (typeof store.reLoad === 'function') { try { await store.reLoad(); } catch (e) {} }
      store.openCart();
      return true;
    }
    /* Adds the section's discount code (e.g. TRAVEL30) to the cart, keeping any code already there.
       Shopify still checks the code's own rules (minimum items, eligible products) at checkout. */
    async applyDiscountCode(root) {
      var code = (this.dataset.discountCode || '').trim();
      if (!code) return;
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        var codes = [code];
        try {
          var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          (cart.discount_codes || []).forEach(function (d) {
            if (d && d.code && codes.every(function (c) { return c.toLowerCase() !== d.code.toLowerCase(); })) codes.push(d.code);
          });
        } catch (e) {}
        var res = await fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ discount: codes.join(',') }) });
        if (!res.ok) throw new Error('cart/update.js ' + res.status);
      } catch (err) {
        /* Fallback: Shopify's discount link saves the code for checkout */
        try { await fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
      }
    }
    async addToCart() {
      if (!this.complete || this._busy) return;
      var self = this;
      var bundleId = 'MB' + Date.now().toString(36).toUpperCase();
      var name = this.dataset.bundleName || 'Bundle';
      var label = this.dataset.propertyLabel || 'Bundle';
      var items = this.slots.map(function (s) {
        var props = { _bundle: name, _bundle_id: bundleId };
        if (self.dataset.showProperty === 'true') props[label] = name;
        return { id: Number(s.variant.id), quantity: 1, properties: props };
      });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this._busy = true;
      this.button.disabled = true;
      if (this.button === this.reviewAdd && this.rv.label && this.reviewAdd.dataset.adding) this.rv.label.textContent = this.reviewAdd.dataset.adding;
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || this.t.error);
        await this.applyDiscountCode(root);
        document.dispatchEvent(new CustomEvent('mome:bundle-added', { detail: { bundleId: bundleId, items: items } }));
        var after = this.dataset.afterAdd || 'drawer';
        if (after === 'cart' || (after === 'drawer' && !(await this.openEurusDrawer()))) {
          window.location.href = root + 'cart';
          return;
        }
        this._keepStatus = true;
        this.out.status.textContent = this.t.success + ' ';
        var a = el('a', null, this.t.viewCart);
        a.href = root + 'cart';
        this.out.status.appendChild(a);
        this.out.status.classList.add('is-success');
      } catch (err) {
        this._keepStatus = true;
        this.out.status.textContent = err.message || this.t.error;
        this.out.status.classList.add('is-error');
      } finally {
        this._busy = false;
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-busy');
        this.update();
        if (this.step === 2) this.renderReviewStep();
      }
    }
  }

  customElements.define('mome-bundle-picker', MomeBundlePicker);
})();